// extracted by mini-css-extract-plugin
export default {"heading":"form-frame_heading__8BWFb","container":"form-frame_container__2FCjL"};